import { ROUTE_SEGMENTS, type NavItemSegment } from "@/constants/navigation";

export const USER_FEATURE_TYPE = {
  EXECUTIVE_SUMMARY: "executiveSummary",
  CHANNEL_DETAIL: "channelDetail",
  SPARX_CATALOG: "sparxsCatalog",
  SPARXS_EDITOR: "sparxsEditor",
  SVG_ALTERATION: "svgAlteration",
} as const;

export type UserFeatureType =
  (typeof USER_FEATURE_TYPE)[keyof typeof USER_FEATURE_TYPE];

export type UserProfileCanAccess = Record<UserFeatureType, boolean>;

export const NAV_ITEM_SEGMENT_TO_USER_FEATURE_TYPE: Record<
  NavItemSegment,
  UserFeatureType
> = {
  [ROUTE_SEGMENTS.EXECUTIVE_SUMMARY]: USER_FEATURE_TYPE.EXECUTIVE_SUMMARY,
  [ROUTE_SEGMENTS.CHANNEL_DETAIL]: USER_FEATURE_TYPE.CHANNEL_DETAIL,
  [ROUTE_SEGMENTS.SPARX_CATALOG]: USER_FEATURE_TYPE.SPARX_CATALOG,
  [ROUTE_SEGMENTS.SPARXS_EDITOR]: USER_FEATURE_TYPE.SPARXS_EDITOR,
  [ROUTE_SEGMENTS.SVG_ALTERATION]: USER_FEATURE_TYPE.SVG_ALTERATION,
};
